import React from 'react';

import { WebModal } from '@components/Modals/WebModal.web';
import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';
import { useInvalidatePublicCalendarUrlMutation } from '@graphql/generated';
import useMe from '@hooks/useMe';

interface InvalidateCalendarUrlModalProps {
  onClose: () => void;
  visible: boolean;
}

const InvalidateCalendarUrlModal: React.FC<InvalidateCalendarUrlModalProps> = ({
  onClose,
  visible,
}) => {
  const [invalidatePublicCalendarUrl] =
    useInvalidatePublicCalendarUrlMutation();
  const { refetchMe } = useMe();

  const handleInvalidate = () => {
    invalidatePublicCalendarUrl().then((_) =>
      refetchMe().then((_) => {
        onClose();
      })
    );
  };

  return (
    <WebModal
      accessibilityLabel='Invalidate Calendar Url Modal'
      width={400}
      height={290}
      title='Are you sure you want to disable the link?'
      titleVariant='heading2'
      titleColor='textPrimary'
      marginHorizontal='l'
      marginTop='l'
      onClose={onClose}
      visible={visible}>
      <>
        <Box marginTop='l'>
          <Text variant='bodySecondary' marginHorizontal='m' marginVertical='m'>
            If you disable this calendar, any existing links will no longer be
            active. You can enable and generate a new link at any time
          </Text>
        </Box>
        <Box
          flexDirection='row'
          flex={1}
          justifyContent='space-around'
          alignItems='stretch'
          paddingHorizontal='m'
          mb='m'>
          <Button
            borderColor='black'
            isSmall
            backgroundColor='white'
            onPress={onClose}
            paddingHorizontal='xl'>
            <Text variant='buttonLabel' color='black'>
              Keep
            </Text>
          </Button>
          <Button
            borderColor='textPrimary'
            isSmall
            backgroundColor='black'
            onPress={handleInvalidate}>
            <Text variant='buttonLabel' color='white'>
              Yes, disable
            </Text>
          </Button>
        </Box>
      </>
    </WebModal>
  );
};

export default InvalidateCalendarUrlModal;
